t = require('app/scripts/views/internal/teacup-with-helpers')('header_enterprise_deprovisioning')
Dates = require 'app/scripts/lib/dates'

module.exports = t.renderable ({ enterpriseName, enterpriseStanding, pendingDeprovision })->
  t.p '.u-bottom', ->
    msgTemplate = if enterpriseStanding == 1 then 'overdue-payment' else 'overdue-renewal'
    t.format msgTemplate , {
      enterpriseName,
      deprovisioningDate: Dates.toDateString(pendingDeprovision),
    }

    t.a '.header-banner-link-left.quiet.js-dismiss-enterprise-deprovisioning-banner.u-float-right', { href: "#" }, ->
      t.icon 'close'
